import { css } from 'styled-components';
import typographyCss from './typography-css';
import animationCss from './animation-css';
import spacingCss from './spacing-css';
import otherCss from './other-css';

const utilities = css`
  ${animationCss}
  ${spacingCss}
  ${typographyCss}
  ${otherCss}
`;

export default utilities;
